import {PermissionList} from '@/libs/defaultList';

export default [
  {
    header: "Pages & Modules",
  },
  {
    title: 'Home',

    icon: 'FileTextIcon',
    route: 'landing1',
  },


  {
    title: 'Marketing',
    permissions: PermissionList.Marketing_View,
    icon: 'CalendarIcon',
    children: [
      {
            //Calenderer
            title: "Plans",
            route: "marketing-plan-calender",
        permissions: PermissionList.Marketing_View,
      },
        {
            title: "Campaigns",
            route: "marketing-campaign-list",
        permissions: PermissionList.Marketing_View,
      },

        {
            title: "Leads",
            route: "marketing-leads",
        permissions: PermissionList.Marketing_View,
      },

        {
            title: "Settings",
            route: "email-list",
        permissions: PermissionList.Marketing_View,
      },

      {
        title: 'Templates',
        route: 'content-templates',
        permissions: PermissionList.Marketing_View,
      },

      // {
      //   title: 'Marketing Chat',
      //   route: 'marketing-chat',
      // },
    ],
  },
  {
    title: 'Ecommerce',
     permissions: PermissionList.ECommerce_View,
    icon: 'CalendarIcon',
    children: [
      {
        //Calenderer
        title: "Set up",
        route: "/ecommerce-setup",
        permissions: PermissionList.ECommerce_Create,

  },
      // {
      //       //Calenderer
      //       title: "Users",
      //       route: "/ecommerce-user",
      //       permissions: PermissionList.ECommerce_Create,

      // },
      {
        //Calenderer
        title: "Order",
        route: "/ecommerce-order",
        permissions: PermissionList.ECommerce_Create,

  },

       
    ],
  },
  {
    title: 'ELearning',
    permissions: PermissionList.ELearning_Create,
    icon: 'BookIcon',
    route: 'elearning-list',
  },
  {
    title: 'CRM',

    icon: "UserIcon",
    permissions: PermissionList.Sales_View,
    children: [
      {
        title: "Leads",
            route: "leads-list",
            permissions: PermissionList.Sales_View,
      },
      {
        title: 'Customers',
        route: { name: 'customer-list' },
        permissions: PermissionList.Sales_View,
      },

      {
        title: 'Complaints',
        route: { name: 'complaint-list' },
        permissions: PermissionList.Sales_View,
      },
    ],
  },

  {
    title: "Sales",

    icon: "ShoppingCartIcon",
    permissions: PermissionList.Sales_View,
    children: [
      {
        title: "Opportunity",
            route: "opportunity-list",
            permissions: PermissionList.Sales_View,
      },
      // {
      //   title: 'Service Request',
      //   route: 'request-list',
      // },
      // {
      //   title: "Leads",
      //   route: "leads-list",
      // },
      // {
      //   title: "Customers",
      //   route: { name: "customer-list" },
      // },
      // {
      //   title: "Complaints",
      //   route: { name: "complaint-list" },
      // },
      // {
      //   title: "Pipeline",
      //   route: { name: "pipeline" },
      // },
      {
        title: 'Quotations',
        route: { name: 'quotation-list' },
        permissions: PermissionList.Sales_View,
      },
      {
        title: 'Proforma',
        route:  { name: 'proforma-list' },
        permissions: PermissionList.Sales_View,
      },
      {
        title: 'Invoices',
        route: 'invoice-list',
        permissions: PermissionList.Sales_View,
      },

    ],
  },
  {
    title: 'Inventory',
    permissions: PermissionList.Inventory_View,
    icon: 'PackageIcon',
    children: [
      {
        title: 'Items',
        children: [
          {
            title: 'Products',
            route: 'product-list',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Raw Materials',
            route: 'rawmaterials-list',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Categories',
            route: 'itemcategories',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Low Stock Refill',
            route: 'lowstock-list',
            permissions: PermissionList.Inventory_View,
          }
        ],
      },
      {
        title: 'Purchasing',
        children: [
          {
            title: 'Suppliers',
            route: 'supplier-list',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Warehouses',
            route: 'warehouse-list',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Purchase Orders',
            route: 'purchaseorders-list',
            permissions: PermissionList.Inventory_View,
          },
          {
            title: 'Purchase Invoices',
            route: 'purchaseinvoices-list',
            permissions: PermissionList.Inventory_View,
          }
        ],
      },
      {
        title: 'Transactions',
        route: 'inventory-transaction-list',
        permissions: PermissionList.Inventory_View,
      }
    ],
  },
  
  {
    title: 'Services',
      icon: 'LayersIcon',
      permissions: PermissionList.ServiceManagement_View,
    children: [
      // {
      //   title: 'Templates',
      //   route: 'templates',
      // },
      {
        title: "Service Template",
        route: "templates-list",
        permissions: PermissionList.ServiceManagement_View,
      },
      // {
      //   title: 'Service Request',
      //   route: 'request-list',
      // },
      // {
      //   title: 'Order Template',
      //   route: 'ordertemplate-list',
      // },
      {
        title: "Service Order",
        route: "serviceorder-list",
        permissions: PermissionList.ServiceManagement_View,
      },
      {
        title: "Timesheet",
        route: "servicetimesheet-list",
        permissions: PermissionList.ServiceManagement_View,
      },
    ],
  },
  {
    title: 'Project Management',
    permissions: PermissionList.ProjectManagement_View,
      icon: 'FileTextIcon',
      children: [
          {
              title: "Project",
              route: "project-list",
              permissions: PermissionList.ProjectManagement_View,
          },
          {
              title: "Timesheet",
              route: "projectmanagementtimesheet-list",
              permissions: PermissionList.ProjectManagement_View,
          },
      ],
  },
  {
    title: 'HR Management',
    permissions: PermissionList.HRMS_View,
    icon: 'UsersIcon',
    children: [
      {
        title: 'Employee',
        route: 'employee-listing',
        permissions: PermissionList.HRMS_View,
      },
      {
        title: 'Payroll',
        children: [
          {
            title: 'Payroll',
            route: 'payroll-listing',
            permissions: PermissionList.HRMS_Finance,
          },
          {
            title: 'My Payroll',
            route: 'payroll-employee',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Allocations',
            route: 'employeeallocation-listing',
            permissions: PermissionList.HRMS_Create,
          }
        ]
      },
      {
        title: 'Leaves',
        children: [
          {
            title: 'Leave Request',
            route: 'leave-request',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Leave Approval',
            route: 'leave-approval',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Leave Balance',
            route: 'leave-balance',
            permissions: PermissionList.HRMS_View,
          }
        ]
      },
      {
        title: 'Attendance',
        children: [
          {
            title: 'Attendance',
            route: 'attendance-listing',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Events',
            route: 'events-listing',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Timesheet',
            route: 'timesheet-listing',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Approve Timesheet',
            route: 'timesheet-approval',
            permissions: PermissionList.HRMS_View,
          },
          {
            title: 'Workforce Tracking',
            route: 'workforce-tracking',
            permissions: PermissionList.HRMS_View,
          }
        ]
      },
      {
        title: 'Rewards',
        route: 'performance-listing',
        permissions: PermissionList.HRMS_Create,
      },
      {
        title: 'Setup',
        icon: 'SettingsIcon',
        permissions: PermissionList.HRMS_Create,
        children: [
          {
            title: 'Leave Types',
            route: 'leave-types',
            permissions: PermissionList.HRMS_Create,
          },
          {
            title: 'Designation',
            route: 'designation-listing',
            permissions: PermissionList.HRMS_Create,
          },
          {
            title: 'Department',
            route: 'department-listing',
            permissions: PermissionList.HRMS_Create,
          }
        ]
      }
    ]
  },
  
  {
    title: 'Equipment',
    permissions: PermissionList.Inventory_View,
    icon: 'ToolIcon',
    route: 'equipment-list',
  },
  {
    title: 'Production',
    permissions: PermissionList.Production_View,
    icon: 'TruckIcon',
    children: [
      {
        title: 'Job Cards',
        route: 'jobcard-list',
        permissions: PermissionList.Production_View,
      },

      {
        title: 'Planning & Monitoring',
        route: 'monitoring-plan-calender',
        permissions: PermissionList.Production_View,
        },
        {
            title: 'Timesheet',
            route: 'jobcardtimesheet-list',
            permissions: PermissionList.Production_View,
        },
    ],
  },
  {
    title: "Accounting",
    icon: "PercentIcon",
    permissions: PermissionList.Accounting_View,
    children: [
      {
        title: "Chart Of Accounts",
        route: "chartofaccounts-list",
        permissions: PermissionList.Accounting_View,
      },
      {
        title: "Tax Setup",
        route: "taxsetup-list",
        permissions: PermissionList.Accounting_View,
      },
      {
        title: "Journal Entry",
        route: "journalentry-list",
        permissions: PermissionList.Accounting_View,
      },
      // {
      //   title: "Trial Balance",
      //   route: "trialbalance",
      //   permissions: PermissionList.Accounting_View,
      // },
      {
        title: "Bank",
        route: "bank",
        permissions: PermissionList.Accounting_View,
      },
      {
        title: "Budget",
        route: "accounting-budget",
        permissions: PermissionList.Accounting_View,
      },
      {
        title: "Sustainability analytics",
        route: "accounting-metrics",
        permissions: PermissionList.Accounting_View,
      },
    ],
  },
  {
    title: "Delivery",
    icon: "TruckIcon",
    permissions: PermissionList.Distribution_View,
    children: [

      {
        title: "Deliveries",
        route: "deliveries",
        permissions: PermissionList.Distribution_View,
      },
      {
        title: "Monitoring",
        route: "monitor-delivery",
        permissions: PermissionList.Distribution_View,
      },

      {
        title: "Vehicle",
        route: "vehicle",
        permissions: PermissionList.Distribution_View,
      },
      {
        title: "GPS Device",
        route: "gps-device",
        permissions: PermissionList.Distribution_View,
      },

    ],
  },
  {
    title: 'Website Builder',
    icon: 'GlobeIcon',
    route: 'websitebuilder',
    permissions: PermissionList.WebsiteBuilder_View,
  },
  {
    title: 'Reports',
    permissions: PermissionList.Reporting_View,
    icon: 'BarChartIcon',
    children: [
      {
        title: "Accounting Reports",
        route: "accountingreports",
        permissions: PermissionList.Accounting_View,
      },
      {
        title: "Sales Reports",
        route: "reports-sales",
        permissions: PermissionList.Sales_View,
      },
      {
        title: "Inventory Reports",
        route: "reports-inventory",
        permissions: PermissionList.Inventory_View,
      },
      {
        title: "Production Reports",
        route: "reports-production",
        permissions: PermissionList.Production_View,
      },

      {
        title: "Marketing Reports",
        route: "reports-marketing",
        permissions: PermissionList.Marketing_View,
      },
      {
        title: "Projects Reports",
        route: "reports-project",
       
      },
    ],
  },
  {
    title: 'BI Tools',
    permissions: PermissionList.Reporting_View,
    icon: 'BarChartIcon',
    route: 'bireport',
  },
  {
    title: 'Users',
    permissions: PermissionList.Users_View,
    icon: 'UserXIcon',
    children: [
      {
        title: 'Users',
        route: 'role-users',
        permissions: PermissionList.Users_View,
      },
      {
        title: 'Roles',
        route: 'role-list',
        permissions: PermissionList.Roles_View,
      },
      {
        title: 'Company',
        route: 'role-tenant',
        permissions: PermissionList.Tenants_View,
      },
    ],
  },
  //{
  //  title: 'Support',
  //  permissions: PermissionList.Support_View,
  //  icon: 'HeadphonesIcon',
  //  route: 'support-dashboard',
  //},
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    route: 'pages-account-setting'
  },
];
